<!--The content below is only a placeholder and can be replaced.-->
<router-outlet></router-outlet>
<lib-ph-loader></lib-ph-loader>